import React from "react";
import { defineMessages } from "react-intl";
import { ListInspect } from "cci-component";
import { Route } from "cci-utility";
import { PrimaryPage } from "cci-admin";
import List from "../view/applicationuser/List";
import Inspect from "../view/applicationuser/Inspect";

const messages = defineMessages({
  applicationUserPlaceholder: {
    id: "applicationUserPlaceholder",
    defaultMessage: "Select a user to see its detail."
  }
});

/**
 * List / Inspect Page for the ApplicationUser entity.
 *
 * This page allows to create, update and search for users.
 */
const ApplicationUsersPage = props => {
  const route = props.rootPath || "users";
  return (
    <PrimaryPage>
      <ListInspect
        rootPath={`/${route}`}
        left={List}
        right={Inspect}
        placeholderMessage={messages.applicationUserPlaceholder}
        selectionPath={`/${route}/:id`}
        leftRightOptions={props}
      />
    </PrimaryPage>
  );
};

export default ApplicationUsersPage;
